import invariant from 'invariant';
import { createSelector } from 'reselect';
import { INITIAL_BOOKING_ROOT_KEY } from '../constants';

const initialBookingStateSelector = createSelector(
    (state) => {
        invariant(
            state.hasOwnProperty(INITIAL_BOOKING_ROOT_KEY),
            `Expected the scheduling state to be available as \`state.${INITIAL_BOOKING_ROOT_KEY}\`. ` +
                "Ensure you have added the `schedulingReducer` to your store's " +
                'reducers via `combineReducers`.'
        );

        return state[INITIAL_BOOKING_ROOT_KEY];
    },
    (initialBookingState) => initialBookingState
);

export default initialBookingStateSelector;
